<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import Button from '../../lib/Button.svelte';
  export let stepData: any;
  export let displayReport: boolean = false;
  export let nextDisabled: boolean = false;
  export let onGenerateBriefClick: (() => void) | undefined = undefined;

  const dispatch = createEventDispatcher();

  function handleNavigation(e: MouseEvent) {
    const dir = (e.currentTarget as HTMLElement)?.getAttribute("data-dir");
    if (dir === "next" && displayReport && onGenerateBriefClick) {
      onGenerateBriefClick();
      return;
    }
    dispatch('navigate', { dir });
  }
</script>

<div class="ui">
{#if stepData.step_prev}
    <button type="button" data-dir="prev" on:click={handleNavigation} class="ui circular icon button" aria-label="Previous step"><i class="angle left icon" aria-hidden="true"></i></button>
{/if}
{#if stepData.step_next}
    <button type="button" data-dir="next" on:click={handleNavigation} disabled={nextDisabled} class="ui circular button icon black right floated" aria-label={displayReport ? 'Write the brief' : 'Next step'}>{#if displayReport }Write the brief {:else}<i class="angle right icon" aria-hidden="true"></i>{/if}</button>
{/if}
</div>



